import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkspaceStoreState } from '../types';

export const workspaceState = createFeatureSelector<WorkspaceStoreState>('workspace');

export const selectWorkspaceFields = createSelector(
  workspaceState,
  (state: WorkspaceStoreState) => state?.fields || {}
);
